// getters
const restaurantProductsSubCategories = state => state.restaurantProductsSubCategories

export default {
  restaurantProductsSubCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/subcategories/getters.js